import React, { useState, useEffect, useMemo } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import moment from 'moment/min/moment-with-locales';
import { colors } from "../components/Theme/WebTheme";
import AlertDialog from "../components/AlertDialog";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Switch from "@mui/material/Switch";
import { Typography, } from "@mui/material";
import {WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, formatUserAmount, formatUserField} from "../common/sharedFunctions"
import { buildDriverEarningsIndex } from "../common/partnerEarnings";
import EditIcon from '@mui/icons-material/Edit';
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { useUsersPage } from '../common/useUsersPage';
import UsersPageFooter from '../components/UsersPageFooter';

export default function Users() {
  const navigate = useNavigate();
  const {id} = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editUser,
    deleteUser,
    fetchUsersPage,
  } = api;
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const dispatch = useDispatch();
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const MAIN_COLOR = WEB_MAIN_COLOR(settings?.appCat);
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);
  const fleetScopeUid =
    auth.profile?.usertype === 'fleetadmin' ? auth.profile.uid : null;
  const {
    items,
    loading,
    error,
    hasMore,
    loadMore,
    refresh,
  } = useUsersPage('driver', {
    fleetadminUid: fleetScopeUid,
    enabled:
      auth.profile?.usertype === 'admin' ||
      auth.profile?.usertype === 'fleetadmin',
  });
  const fleetAdminItems = useSelector(
    (state) => state.usersdata.usersPage?.fleetadmin?.items || []
  );
  const sortedData = useMemo(
    () =>
      [...items].sort((a, b) => moment(b.createdAt) - moment(a.createdAt)),
    [items]
  );
  
  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    if (role === 'admin') {
      dispatch(fetchUsersPage({ usertype: 'fleetadmin', limit: 100, append: false }));
    }
  }, [dispatch, fetchUsersPage, role]);

  useEffect(() => {
    if (role !== 'admin' || !fleetAdminItems.length) {
      return;
    }
    const obj = {};
    fleetAdminItems.forEach((user) => {
      obj[user.id] =
        user.firstName +
        ' ' +
        user.lastName +
        ' (' +
        (settings.AllowCriticalEditsAdmin ? user.mobile : t('hidden_demo')) +
        ') ' +
        (settings.AllowCriticalEditsAdmin ? user.email : t('hidden_demo'));
    });
    setFleetAdminsObj(obj);
  }, [fleetAdminItems, role, settings.AllowCriticalEditsAdmin, t]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const driverEarningsIndex = useMemo(
    () => buildDriverEarningsIndex(bookinglistdata.bookings, settings),
    [bookinglistdata.bookings, settings]
  );

 
  const handelApproved = (rowData) => {
    const updatedUser = { ...rowData, approved: !rowData.approved, adminApprovedTrue:true,  };

    dispatch(editUser(updatedUser.id, updatedUser));
    return updatedUser;
  };
  const handelDriverActiveStatus = (rowData) => {
    const updatedUser = {
      ...rowData,
      driverActiveStatus: !rowData.driverActiveStatus,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    return updatedUser;
  };

  const columns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc',render: rowData => rowData.createdAt? moment(rowData.createdAt).format('lll'):null,},

    { title: t("first_name"), field: "firstName", initialEditValue: "" },
    { title: t("last_name"), field: "lastName", initialEditValue: "" },
    {
      title: t("wallet_balance", { defaultValue: "Saldo de la billetera" }),
      field: "walletBalance",
      editable: "never",
      render: (rowData) => formatUserAmount(rowData.walletBalance, settings),
    },
    {
      title: t("ad_balance_label", { defaultValue: "Saldo para prioridad" }),
      field: "adBalance",
      editable: "never",
      render: (rowData) => formatUserAmount(rowData.adBalance, settings),
    },
    {
      title: t("partner_platform_utility_month", { defaultValue: "Utilidad plataforma (mes)" }),
      field: "platformUtilityMonth",
      editable: "never",
      render: (rowData) =>
        formatUserAmount(driverEarningsIndex[rowData.id]?.month?.platform, settings),
    },
    {
      title: t("partner_driver_earnings_month", { defaultValue: "Ganancia socio (mes)" }),
      field: "driverEarningsMonth",
      editable: "never",
      render: (rowData) =>
        formatUserAmount(driverEarningsIndex[rowData.id]?.month?.driver, settings),
    },
    {
      title: t("partner_platform_utility_total", { defaultValue: "Utilidad plataforma (total)" }),
      field: "platformUtilityTotal",
      editable: "never",
      render: (rowData) =>
        formatUserAmount(driverEarningsIndex[rowData.id]?.lifetime?.platform, settings),
    },
    {
      title: t("address_home_company", { defaultValue: "Dirección" }),
      field: "address",
      editable: "never",
      render: (rowData) => formatUserField(rowData.address, t),
    },
    {
      title: t("municipality", { defaultValue: "Ciudad / Municipio" }),
      field: "municipality",
      editable: "never",
      render: (rowData) => formatUserField(rowData.municipality, t),
    },
    {
      title: t("department", { defaultValue: "Departamento" }),
      field: "department",
      editable: "never",
      render: (rowData) => formatUserField(rowData.department, t),
    },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo"),
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : t("hidden_demo"),
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
    },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled={!settings.AllowCriticalEditsAdmin}
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
        />
      ),
    },
    {
      title: t("driver_active"),
      field: "driverActiveStatus",
      editable: "never",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled={!(settings.AllowCriticalEditsAdmin && role === "admin")}
          checked={rowData.driverActiveStatus}
          onChange={() => handelDriverActiveStatus(rowData)}
        />
      ),
    },
    {
      title: t("queue"),
      field: "queue",
      editable: "never",
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.queue}
          onChange={() => console.log(rowData.queue)}
        />
      ),
    }
  ];

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };


  const [selectedRow, setSelectedRow] = useState(null);

  return loading && !items.length ? (
    <CircularLoading />
  ) : (
    <div style={{ backgroundColor: colors.LandingPage_Background }}>
      <ThemeProvider theme={theme}>
        <MaterialTable
          title={t("drivers_title")}
          columns={columns}
          onChangePage={(page) => HandalePageChange(page)}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: "20px",
          }}
          data={sortedData}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            initialPage: state?.pageNo,
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt =
                  new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString();
                row.fleetadmin = row.fleetadmin
                  ? fleetAdminsObj[row.fleetadmin]
                  : "";
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "download.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
            }),
            ...TableStyle(settings)
          }}
          localization={localization(t)}
          editable={{
            onRowDelete: (oldData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(deleteUser(oldData.id));
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(t("demo_mode"));
                    }, 600);
                  }),
          }}
          actions={[
            {
              icon: "add",
              tooltip: t("add_driver"),
              isFreeAction: true,
              onClick: (event) => navigate("/users/edituser/driver",{state:{pageNo:currentPage}}),
            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginRight:0
                }}
              >
                <EditIcon />  
              </div>
            ),
            onClick: (event, rowData) =>{
              navigate(`/users/edituser/driver/${rowData.id}`,{state:{pageNo:currentPage}})
            }
          }),
            {
              icon: "info",
              tooltip: t("profile_page_subtitle"),
              onClick: (event, rowData) => {
                navigate(`/users/driverdetails/${rowData.id}`,{state:{pageNo:currentPage}});
              },
            },
            ...(role === "admin" && settings.AllowCriticalEditsAdmin ? [{
              icon: () => <AccountBalanceWalletIcon style={{ color: MAIN_COLOR }} />,
              tooltip: t('admin_driver_wallet_title', { defaultValue: 'Recargar billetera del conductor' }),
              onClick: (event, rowData) => {
                navigate(`/addtowallet?uid=${encodeURIComponent(rowData.id)}`);
              },
            }] : []),
            (rowData) => ({
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: 10,
                    backgroundColor: MAIN_COLOR,
                    borderRadius: 5,
                  }}
                >
                  <Typography style={{ color: colors.LandingPage_Background }}>
                    {t("documents")}
                  </Typography>
                </div>
              ),
              tooltip: t("documents"),
              onClick: () => navigate(`/users/userdocuments/${id}/${rowData.id}`,{state:{pageNo:currentPage}}),
            }),
          ]}
        />
        <UsersPageFooter
          count={sortedData.length}
          hasMore={hasMore}
          loading={loading}
          error={error}
          onLoadMore={loadMore}
          onRetry={refresh}
        />
        </ThemeProvider>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
